import { InjectionTokens } from '@/controller/tokens'

import { IFeatureFlagsRepository } from '@/data/FeatureFlagsRepository/IFeatureFlagsRepository'

import { useInjection } from '../contexts/InjectionContext'

const useFeatureFlags = () => {
  const featureFlagsRepository = useInjection<IFeatureFlagsRepository>(InjectionTokens.FeatureFlagsRepository)
  const flagsSnapshot = featureFlagsRepository.getFeatureFlags()

  return flagsSnapshot
}

export { useFeatureFlags }
